module.exports = __webpack_public_path__ + "img/instagram.d510474f.svg";